import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function PointsManagement() {
  const [tab, setTab] = useState('rules')
  const [children, setChildren] = useState([])
  const [selectedChild, setSelectedChild] = useState(null)
  const [pointsData, setPointsData] = useState(null)
  const [leaderboard, setLeaderboard] = useState([])
  const [rules, setRules] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { loadChildren(); loadLeaderboard(); loadRules() }, [])

  const loadChildren = () => { fetch(`${API}/children`).then(r => r.json()).then(d => { if (d.success) setChildren(d.data || []) }) }
  const loadLeaderboard = () => { fetch(`${API}/points/leaderboard/all`).then(r => r.json()).then(d => { if (d.success) setLeaderboard(d.data || []) }) }
  const loadRules = () => { fetch(`${API}/points/config/rules`).then(r => r.json()).then(d => { if (d.success) setRules(d.data || []) }).finally(() => setLoading(false)) }

  const loadChildPoints = (childId) => { setLoading(true); fetch(`${API}/points/${childId}`).then(r => r.json()).then(d => { if (d.success) setPointsData(d.data) }).finally(() => setLoading(false)) }

  const handleAddPoints = () => {
    if (!selectedChild) { alert('请先选择孩子'); return }
    const amount = prompt('请输入积分数量（正数增加，负数扣减）：')
    if (!amount) return
    const source = prompt('请输入来源（如：购买课程、完成课时、分享等）：')
    const remark = prompt('备注（可选）：')
    fetch(`${API}/points/${selectedChild.id}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ type: Number(amount) > 0 ? 'earn' : 'spend', amount: Math.abs(Number(amount)), source: source || '管理员调整', remark }) })
      .then(r => r.json()).then(d => { if (d.success) { alert('积分调整成功'); loadChildPoints(selectedChild.id); loadLeaderboard() } else alert('调整失败') }).catch(() => alert('调整失败'))
  }

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📊 会员积分管理</h2>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        {[{ k: 'rules', l: '积分规则' }, { k: 'leaderboard', l: '积分排行' }, { k: 'adjust', l: '手动调整' }].map(t => (
          <button key={t.k} onClick={() => setTab(t.k)} style={{ padding: '8px 16px', border: 'none', borderRadius: 6, background: tab === t.k ? '#1890ff' : '#f5f5f5', color: tab === t.k ? '#fff' : '#666', cursor: 'pointer', fontSize: 13 }}>{t.l}</button>
        ))}
      </div>

      {tab === 'rules' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
          <h3 style={{ fontSize: 14, marginBottom: 16 }}>💡 积分规则</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            {[{ action: '完成课时', points: '+10' }, { action: '获得成就', points: '+20' }, { action: '分享作品', points: '+5' }, { action: '购买课程', points: '+50' }, { action: '连续学习7天', points: '+30' }].map(r => (
              <div key={r.action} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 16px', background: '#fafafa', borderRadius: 6 }}>
                <span>{r.action}</span><span style={{ color: '#52c41a', fontWeight: 600 }}>{r.points}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab === 'leaderboard' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}>{['排名', '孩子', '积分', '等级'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {leaderboard.map((c, i) => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ ...td, fontWeight: 700, color: i === 0 ? '#fa8c16' : i === 1 ? '#999' : i === 2 ? '#cd7f32' : '#666' }}>{i + 1}</td>
                  <td style={td}>{c.name}</td>
                  <td style={{ ...td, color: '#52c41a', fontWeight: 600 }}>{c.points || 0}</td>
                  <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#e6f4ff', color: '#1890ff' }}>{c.level || '初级'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'adjust' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
          <h3 style={{ fontSize: 14, marginBottom: 16 }}>手动调整积分</h3>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>选择孩子</label>
            <select onChange={e => { const c = children.find(x => x.id === e.target.value); setSelectedChild(c); if (c) loadChildPoints(c.id) }} style={{ padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6, width: 300, fontSize: 14 }}>
              <option value="">请选择孩子</option>
              {children.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          {pointsData && (
            <div style={{ padding: 16, background: '#f6ffed', borderRadius: 8, marginBottom: 16 }}>
              <div style={{ fontSize: 13, color: '#666' }}>当前积分：<span style={{ fontSize: 24, fontWeight: 600, color: '#52c41a' }}>{pointsData.balance || 0}</span></div>
            </div>
          )}
          <button onClick={handleAddPoints} style={{ padding: '10px 24px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>调整积分</button>
        </div>
      )}
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
